module.exports = __webpack_public_path__ + "static/media/drop-down-n.79c8b038.svg";